module.exports = __webpack_public_path__ + "mo/img/piece-06.c35493a6.svg";